import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'headerSidebar',
  //---components
  components: {},
  props: ['menu','links','btns'],
  //---data
  data () {
    return {}
  },
  //---hooks
  computed: {
    ...mapGetters({
      isShowSidebar: 'APP/isHeaderSidebarShow',
      user: 'AUTH/user',
    }),
  },
  //---methods
  methods: {
    ...mapMutations({
      setHeaderSidebarFlag: 'APP/APP_HEADER_SIDEBAR_SHOW_FLAG_TOGGLE',
      popupOpen: 'APP/APP_POPUP_OPEN'
    }),
    ...mapActions({
      getLogin: 'AUTH/AUTH_LOGIN_REQUEST',
      getLogout: 'AUTH/AUTH_LOGOUT_REQUEST',
    }),
    toggleHeaderSidebar() {
      this.isShowSidebar ? this.setHeaderSidebarFlag(false) : this.setHeaderSidebarFlag(true);
    },

    auth() {
      if (this.user) {
        this.getLogout().then(()=>{
          if (this.$route.matched.some(record => record.meta.requiresAuth)) {
            this.$router.push({name: 'home'});
          }
        });
      } else {
        this.getLogin();
        this.popupOpen('popupLogin');
      }
      this.toggleHeaderSidebar();
    },

    goToRoute(routeName) {
      if (this.$router.currentRoute.name !== routeName) {
        this.$router.push({name: routeName});
      }
      this.setHeaderSidebarFlag(false)
    },
    goToLink(linkName) {
      window.open(linkName);
      this.setHeaderSidebarFlag(false)
    }
  }
}